<template>
  <div class="relative w-full main-page">
    <div class="pt-5 flex items-between client-status-block rounded-lg top relative">
      <main class="c-container py-10 prose max-w-none flex flex-col gap-6 overflow-y-scroll scroll-styling">

        <h1 class="text-center font-bold">
          Договор-оферта<br />
          на обучение на курсах подготовки операторов БАС 1,2 категории
        </h1>

        <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
        <p>
          1.1. Настоящая Договор-оферта (далее – Договор) представляет собой официальное предложение 
          ТОО «R&amp;D центр «Казахстан инжиниринг», именуемое в дальнейшем «R&amp;D центр», к (ФИО) ________________________________________ 
          ИИН ___________________________________, именуемый в дальнейшем «Слушатель», совместно именуемые как «Стороны», 
          содержащий в себе все существенные условия для заключения договора по обучению на курсах повышения квалификации 
          (далее – Договора по обучению) в соответствии со статьями 393-398 Гражданского Кодекса Республики Казахстан (далее - ГК РК). 
        </p>
        <p>
          1.2. В соответствии с пунктом 1 статьи 395 ГК РК офертой признается предложение о заключении договора, 
          сделанное одному или нескольким конкретным лицам, если оно достаточно определенно и выражает намерение лица, 
          сделавшего предложение, считать себя связанным в случае его принятия (акцепта). 
          Предложение является достаточно определенным, если в нем указаны существенные условия договора или порядок их определения. 
          Акцепт оферты – согласие на подготовку оператора БАС 1 и 2 категории, в соответствии со статьёй 396 ГК РК акцепт – это ответ лица,
          которому адресована оферта, о ее принятии. Акцепт должен быть полным и безоговорочным. 
          Совершая действия по акцепту настоящего Договора, Слушатель подтверждает свою правоспособность и дееспособность, 
          а также свое законное право вступать в договорные отношения с R&amp;D центром.
          Полным и безоговорочным согласием заключить Договор (далее – Акцептом) является выраженное согласие с его условиями 
          путем принятия настоящего Договора во время регистрации в Электронной системе учета слушателей (далее-ЭСУС).
        </p>
        <p>
          Акцепт означает, что Слушатель согласен со всеми положениями настоящей Договора и равносилен заключению Договора по обучению.
          В связи с вышеизложенным, внимательно прочитайте текст Договора. Если Вы не согласны с каким-либо пунктом Договора, 
          R&amp;D центр предлагает Вам отказаться от Акцепта.
        </p>

        <h2>2. ПРЕДМЕТ ДОГОВОРА</h2>
        <p>
          2.1. R&amp;D центр проводит обучение Слушателя по Программе первоначальной теоретической подготовки операторов БАС Категории 1 и    по программам первоначальной теоретической и практической   подготовки операторов БАС категории 2 (далее – Курсы) после прохождения полного курса по категории 2 слушатель демонстрирует независимому экзаменатору практические навыки и получает акт оценки практических навыков.
        </p>
        <p>
          2.2. По настоящему Договору R&amp;D центр проводит обучение Слушателей на курсах повышения квалификации на возмездной основе. 
          Стоимость Курсов указана в Приложении №1 к настоящему Договору.
        </p>

        <h2>3. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
        <p><strong>3.1. R&amp;D центр обязуется:</strong></p>
        <ul>
          <li>3.1.1. провести соответствующие обучение в станционном (аудиоторном)/офлайн дневном формате или онлайн формате;</li>
          <li>3.1.2. представить слушателю по окончании лекции раздаточный материал по данной теме.</li>
          <li>3.1.3. выдать Слушателю сертификаты установленного образца;</li>
        </ul>

        <p><strong>3.2. Слушатель обязуется:</strong></p>
        <ul>
          <li>3.2.1. иметь необходимые технические средства для прохождения обучения;</li>
          <li>3.2.2. предоставлять достоверную информацию при регистрации в ЭСУС;</li>
          <li>3.2.3. своевременно подключаться к Курсу;</li>
          <li>3.2.4. предоставлять необходимые документы по запросу R&amp;D центра;</li>
          <li>3.2.5. своевременно посещать Курсы и выполнять задания;</li>
          <li>3.2.6. проявлять уважение к персоналу R&amp;D центра;</li>
          <li>3.2.7. возместить нанесенный ущерб при его причинении;</li>
          <li>3.2.9. информировать о невозможности выполнения условий договора;</li>
          <li>3.2.10. не разглашать конфиденциальную информацию;</li>
          <li>3.2.11. пройти полный курс;</li>
          <li>3.2.12. подписать Соглашение об обработке персональных данных, Приложение № 2 к настоящему Договору;</li>
          <li>3.2.13. не воспроизводить, не копировать и не передавать обучающие материалы;</li>
          <li>3.2.14. не передавать учетные данные третьим лицам.</li>
        </ul>

        <p><strong>3.3. R&amp;D центр имеет право:</strong></p>
        <ul>
          <li>3.3.1. затребовать отчет о завершении обучения;</li>
          <li>3.3.2. принимать заявления от Слушателя;</li>
          <li>3.3.3. отчислить слушателя с Курсов по основаниям, указанным в Правилах.</li>
          <li>3.3.4. В случае отсутствия мотивированного отказа подписания Слушателем акта выполненных работ (Приложение № 3 к настоящему Договору) в течении 3-х рабочих дней после окончания курса, услуги считаются оказанными в полном объеме и принятыми без подписания акта.</li>
        </ul>

        <p><strong>3.4. Слушатель имеет право:</strong></p>
        <ul>
          <li>3.4.1. на получение качественного обучения;</li>
          <li>3.4.2. завершить прерванный курс по уважительной причине.</li>
        </ul>

        <h2>4. ОТВЕТСТВЕННОСТЬ СТОРОН И ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</h2>
        <p>
          4.1. Стороны обязуются применять досудебный порядок урегулирования спора. 
          В случае невозможности урегулирования — обращение в суд по месту нахождения R&amp;D центра. 
        </p>
        <p>4.2. Ответственность в соответствии с законодательством РК.</p>
        <p>4.3. В случае раскрытия конфиденциальной информации — возмещение ущерба.</p>

        <h2>5. СРОК ДЕЙСТВИЯ ДОГОВОРА</h2>
        <p>5.1. Настоящий Договор вступает в силу с момента принятия Акцепта.</p>
        <p>5.2. Может быть расторгнут по заявлению Слушателя.</p>

        <h2>6. ФОРС-МАЖОР</h2>
        <p>6.1. Стороны освобождаются от обязательств при непреодолимой силе.</p>
        <p>6.2. Оповещение о форс-мажоре в течение 1 дня с документом подтверждения.</p>

        <h2>7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
        <p>7.1. Все изменения только по согласованию Сторон.</p>
        <p>7.2. Нерегулированные вопросы — по законодательству РК.</p>

        <h2>8. РЕКВИЗИТЫ СТОРОН</h2>
        <div class="grid grid-cols-2 gap-4 border p-4">
          <div>
            <strong>R&amp;D центр:</strong><br />
            ТОО «Research & Development центр «Казахстан инжиниринг»<br />
            БИН 100140003741<br />
            Банк АО «Фридом Банк Казахстан»<br />
            ИИК KZ67551Z600000763046 (KZT)<br />
            БИК KSNVKZKA<br />
            БИН 090740019001<br />
            Кбе 17<br />
            Юридический адрес: г. Астана, ул. Ауэзова, 2 н.п.1<br />
            Тел/факс. 8(7172)32-21-24,32-21-39<br />
            e-mail: info@rdke.kz<br /><br />
            Генеральный директор<br />
            _______________________ С. Боранбаев
          </div>
          <div>
            <strong>Слушатель:</strong><br />
            ____________________________________<br />
            ____________________________________
          </div>
        </div>

        <h2 class="text-center mt-10">Приложение № 1</h2>
        <p class="text-center">к Договору № ____ от «___» ___________2026года</p>

        <table class="table-auto border mt-5">
          <thead>
            <tr>
              <th class="border px-4 py-2">Наименование услуги</th>
              <th class="border px-4 py-2">Стоимость, тенге, с учетом НДС</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border px-4 py-2">
                <strong>Обучение операторов беспилотных летательных аппаратов</strong><br />
                БАС категории 1
                <p>
                  <strong>Описание:</strong> Программа первоначальной теоретической подготовки операторов беспилотных авиационных систем (БАС) Категории 1.
                </p>
                <p>
                  Программа состоит из курса теоретической подготовки для операторов БАС Категории 1 (EASY Rating), 
                  эксплуатирующих БАС с беспилотным воздушным судном мультироторного и вертолетного типа конструкции 
                  с максимальной взлетной массой менее 25 кг в личных целях. В Договор
                </p>
                <p>
                  <strong>Общая продолжительность и формат обучения:</strong> 24 часа (4 дня по 6 учебных часов). 
                  Время для самостоятельной работы не включено в аудиторные занятия.
                </p>
                <ul>
                  <li>стационарное дневное;</li>
                  <li>дистанционное;</li>
                  <li>комбинированное;</li>
                  <li>индивидуальное.</li>
                </ul>
              </td>
              <td class="border px-4 py-2 text-center">30 000 тг</td>
            </tr>
          </tbody>
        </table>

        <table class="table-auto border mt-5">
          <thead>
            <tr>
              <th class="border px-4 py-2">Наименование услуги</th>
              <th class="border px-4 py-2">Стоимость, тенге, с учетом НДС</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border px-4 py-2">
                <p>Первоначальная теоретическая подготовка операторов БАС</p>
                <p>Категории 2</p>
                <p>Проводится теоретическое обучение согласно программы, согласованной с ААК с выдачей сертификата государственного образца, за 1 обучаемого</p>
                <p>6 дней онлайн в мобильном приложении</p>
                <p>ТОО «Research &amp; Development центр «Казахстан инжиниринг»</p>
              </td>
              <td class="border px-4 py-2 text-center">50 000</td>
            </tr>
            <tr>
              <td class="border px-4 py-2">
                <p>Первоначальная практическая подготовка операторов БАС</p>
                <p>Категории 2, тип конструкции БВС «Мультироторный»</p>
                <p>Проводится практическое обучение согласно программы, согласованной с ААК с выдачей сертификата государственного образца, за 1 обучаемого</p>
                <p>2 дня г. Астана/ территория</p>
                <p>Заказчика</p>
              </td>
              <td class="border px-4 py-2 text-center">220 000</td>
            </tr>
            <tr>
              <td class="border px-4 py-2">
                <p>Проведение оценки практических навыков (экзамен)</p>
                <p>Проводится с привлечением независимого экзаменатора, за / обучаемого</p>
                <p>1 день/ г. Астана</p>
              </td>
              <td class="border px-4 py-2 text-center">80 000</td>
            </tr>
            <tr>
              <td class="border px-4 py-2">
                <p>Итого за 1 обучаемого</p>
              </td>
              <td class="border px-4 py-2 text-center">350 000</td>
            </tr>
            <tr>
              <td class="border px-4 py-2">
                <p>Первоначальная теоретическая подготовка операторов БАС</p>
              </td>
              <td class="border px-4 py-2"></td>
            </tr>
          </tbody>
        </table>

        <p>В Договор</p>
        <p>Общая продолжительность и формат обучения: 48 часов (6 дней по 8 учебных часов и 2 дня практика 12 часов).</p>
        <p>Курс практической подготовки только в станционном (аудиторном)/офлайн дневном формате</p>
        <p>(4 дня по 4 часа теория и 4 дня по 8 часов практика так как слушатели не успевают пройти курс практики</p>

      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferAgreement",
};
</script>

<style scoped>
.prose :where(h1, h2, h3) {
  color: #111827;
}
.prose a {
  text-decoration: underline;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table th, table td {
  border: 1px solid #000;
  padding: 8px;
}
</style>
